/*****************************************
 * File Name: global js
 * Author: mhk
 * CreateTime: 2020/12/16
 * ***************************************
*/
// 接口地址
const apiUrl = "https://api.sjzeis.com";
// const apiUrl = "http://localhost:8082";

export default {
  apiUrl
};



// WEBPACK FOOTER //
// ./src/utils/global.js